<template>
    <li class="dropdown" id="user-header">
        <a href="#" data-toggle="dropdown" data-hover="dropdown" data-close-others="true" style="padding-top: 3px;">
                <!--<img src="/static/img/avatars/portraitAw1F.png" alt="user image">-->
                <elv-avatar-icon :avatar="viewAsPlayer.avatar" :isFriend="viewAsPlayer.isFriend" />
                <span class="username" style="font-size:90%; color: rgba(0, 0, 0, 0.87); font-family: Lato; line-height: 15px; padding-top:8px;">
                            {{viewAsPlayer.username}}<BR/>
                            <span style="font-size:75%">{{viewAsPlayer.serverName}}</span>
                </span>
        </a>
        <ul class="dropdown-menu">
            <li>
                <a @click="dialog = true"><i class="icon-user"></i><span>{{ $t('site.playerSelection.changeUser') }}</span></a>
                <v-dialog v-model="dialog" persistent max-width="500px">
                    <!--<v-btn color="primary" dark slot="activator">Open Dialog</v-btn>-->
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ $t('site.playerSelection.headline') }}</span>
                            <small>{{ $t('site.playerSelection.description') }}</small>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <elv-player-search-box :emitViewAsPlayer="true"></elv-player-search-box>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="dialog = false">{{ $t('site.common.cancel') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </li>
        </ul>
    </li>
</template>

<script>
    import ElvAvatarIcon from "./ElvAvatarIcon"
    import ElvPlayerSearchBox from "./ElvPlayerSearchBox"

    export default {
        components: {
            ElvPlayerSearchBox,
            ElvAvatarIcon},
        name: "elv-change-view-as-player",
        props: { viewAsPlayer: {required:true} },
        data() {
            return {
                dialog:false,
            }
        },
        created() {
            Event.$on("viewAsPlayer", (data) => {
                console.log("viewAsPlayer received in ElvChangeViewAsPlayer.vue");
                this.dialog = false;
                // NOTE: cookie and viewAsPlayer props are still handled in App.vue.
            });
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ElvChangeViewAsPlayer.vue